export interface IUploadCredentials {
  key: string
  acl: string
  policy: string
  xAmzAlgorithm: string
  xAmzCredential: string
  xAmzDate: string
  xAmzSignature: string
  xAmzSecurityToken: string
}

export enum LooopS3BucketEnum {
  PUBLIC = 'PUBLIC',
  PRIVATE = 'PRIVATE'
}
